import React, { useCallback, useEffect, useState } from 'react'
import styles from '../Student/login.module.css'
import { useNavigate } from 'react-router-dom'
import { useFormik } from "formik"
import * as yup from "yup";
import { Box, Checkbox, CircularProgress, TextField } from '@mui/material';
import { ArrowIcon, GoogleIcon, HidePasswordIcon, LogoIcon, PasswordVisible } from '../../../svg';
import CustomizedCheckbox from '../../../component/CustomizedCheckbox';
import { useDispatch, useSelector } from 'react-redux';
import { registerAffiliate, registerAffiliateWithGoogle } from '../../redux/affiliateRegister'
import {
    signInWithPopup,
    GoogleAuthProvider,
} from "firebase/auth";
import { auth } from '../../helper/firebase';
import { unwrapResult } from '@reduxjs/toolkit';
import PendingModal from '../../../component/PendingModal';
import { AffiliategetProfile } from '../../redux/affiliateSlice';
import Toastify from '../../helper/Toastify';
import AffiliateRegistrationModal from '../../../component/AffiliateRegistrationModal';
import ReCAPTCHA from "react-google-recaptcha";


const AffiliateRegistration = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [otpModal, setOtpModal] = useState(false);
    const [googleErrorMessage, setGoogleErrorMessage] = useState("");
    const [error, setError] = useState(false);
    const [checked, setChecked] = useState(false);
    const [captchaValue, setCaptchaValue] = useState(null);





    const userProfile = useSelector((state) => state.affiliate);
    const getUserProfile = userProfile?.affiliate;

    useEffect(() => {
        dispatch(AffiliategetProfile())
    }, [dispatch])

    useEffect(() => {
        if (getUserProfile?.status === "PENDING") {
            setShowModal(true)
        }
        else {
            setShowModal(false)
        }

    }, [dispatch, getUserProfile])

    // schema -----------
    const schema = yup.object().shape({
        email: yup.string().matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "Please enter valid email").required("Please enter valid email"),
        password: yup.string().required("Password is required"),
        name: yup.string().required("Name is required"),
        phone: yup.string().matches(/^\d{10}$/, 'Phone must be 10 digits').required("Phone is required"),
        confirmPassword: yup.string().required("Confirm Password is required"),
        platforms: yup
            .array()
            .of(yup.string())
            .min(1, "At least one plateform is required"),
    })

    const {
        errors, values, handleChange, touched, setFieldValue, handleBlur, resetForm, handleSubmit,
    } = useFormik({
        initialValues: {
            email: "",
            password: "",
            name: "",
            phone: "",
            confirmPassword: "",
            platforms: []

        },
        validationSchema: schema,
        onSubmit: (values) => {

            if (!captchaValue) {
                Toastify.error("Please verify the reCAPTCHA")
                return;
            }

            handleLogin(values);
        }
    })

    const handleCaptchaChange = (value) => {
        setCaptchaValue(value);
    };

    const handleLogin = async (values) => {

        if (!checked) {
            return Toastify.error("Accept terms and conditions")
        }

        setLoading(true);
        try {
            const result = await dispatch(registerAffiliate(values));
            await unwrapResult(result)
            // setShowModal(true)
            // navigate('/affiliate/affiliateDashboard');
            openModal()
        } catch (error) {
            console.error('Login failed:', error);
        } finally {
            setLoading(false);
        }
    }




    const handleGoogleSignUp = async (e) => {

        console.log('hiiii')
        e.preventDefault();

        // Instantiate a GoogleAuthProvider object
        const provider = new GoogleAuthProvider();

        console.log('hello')

        try {
            // Sign in with a pop-up window
            const result = await signInWithPopup(auth, provider);

            // Pull signed-in user credential.
            const user = result.user;

            console.log("sasaas", result)

            const resultAction = await dispatch(registerAffiliateWithGoogle({
                email: user.email,
                googleIdToken: user.accessToken
            }));

            unwrapResult(resultAction);

            navigate("/affiliate/affiliateDashboard")

        } catch (err) {
            // Handle errors here.
            const errorMessage = err.message;
            const errorCode = err.code;

            setError(true);

            switch (errorCode) {
                case "auth/operation-not-allowed":
                    setGoogleErrorMessage("Email/password accounts are not enabled.");
                    break;
                case "auth/operation-not-supported-in-this-environment":
                    setGoogleErrorMessage("HTTP protocol is not supported. Please use HTTPS.")
                    break;
                case "auth/popup-blocked":
                    setGoogleErrorMessage("Popup has been blocked by the browser. Please allow popups for this website.")
                    break;
                case "auth/popup-closed-by-user":
                    setGoogleErrorMessage("Popup has been closed by the user before finalizing the operation. Please try again.")
                    break;
                default:
                    setGoogleErrorMessage(errorMessage);
                    break;
            }
        }
    };

    const openModal = () => {
        setOtpModal(true)
    }

    const handleCheckboxChange = (e, value) => {
        const { checked } = e.target;
        let updatedPlateforms = [...values.platforms];

        if (checked) {
            // Add the value to the array if the checkbox is checked
            updatedPlateforms.push(value);
        } else {
            // Remove the value from the array if the checkbox is unchecked
            updatedPlateforms = updatedPlateforms.filter((platform) => platform !== value);
        }

        // Update the form state
        setFieldValue('platforms', updatedPlateforms);
    };

    const handleTerms = (e) => {
        setChecked(e.target.checked)
    }

    const maskEmail = (email) => {
        if (!email || typeof email !== 'string') {
            return ""; // Return an empty string or a default masked email if the input is invalid
        }
        const [username, domain] = email?.split("@"); // Split into username and domain
        if (username.length <= 2) {
            // If the username is too short, keep only the first character and mask the rest
            return `${username[0]}***@${domain}`;
        }
        // Otherwise, keep the first two characters and mask the rest
        return `${username.substring(0, 2)}***@${domain}`;
    };

    return (
        <div className={styles.main}>
            <div className={styles.mainContainer}>
                <div style={{ cursor: "pointer" }} onClick={() => navigate("/affiliate/affiliate")}>
                    <LogoIcon />
                </div>
            </div>
            <div className={styles.login}>
                <div className={styles.mobileViewLogin}>
                    <div className={styles.mobileLogoStyle}>
                        <h3>KINGSTER</h3>
                    </div>
                </div>
                <div className={styles.content} style={{ marginTop: 30 }}>
                    <h3>Create an Affiliate account</h3>
                    {/* <p>Please login to continue to your account.</p> */}
                    <form autoComplete='off'>
                        <div style={{ marginTop: 30 }}>
                            <label className={styles.label}>Full Name</label>
                            <div className={styles.inputbox}>
                                <input type='text' onBlur={handleBlur} value={values.name} placeholder='Full Name' name="name" onChange={handleChange} autocomplete="off" />

                            </div>
                            {
                                errors.name && touched.name && <p style={{ color: "red", fontSize: "12px", textAlign: "left" }}>{errors.name}</p>
                            }

                        </div>
                        <div className={styles.inputboxStyle}>
                            <div className={styles.inputMobileResponsive}>
                                <label className={styles.label}>Email</label>
                                <div className={styles.inputBox}>
                                    <input
                                        type='email'
                                        onBlur={handleBlur}
                                        value={values.email}
                                        placeholder='Email Address'
                                        name="email"
                                        onChange={handleChange}
                                        autocomplete="off"
                                    />
                                </div>
                                {
                                    errors.email && touched.email && <p style={{ color: "red", fontSize: "12px", textAlign: "left" }}>{errors.email}</p>
                                }
                            </div>
                            <div className={styles.inputMobileResponsive}>
                                <label className={styles.label}>Phone Number</label>
                                <div className={styles.inputBox}>
                                    <input type='number' onBlur={handleBlur} value={values.phone} placeholder='Phone Number' name="phone" onChange={handleChange} autocomplete="off" />
                                </div>
                                {
                                    errors.phone && touched.phone && <p style={{ color: "red", fontSize: "12px", textAlign: "left" }}>{errors.phone}</p>
                                }
                            </div>
                        </div>
                        {/* <div className={styles.inputMobileResponsive}>
      <label className={styles.label}>Platform</label>
      <div className={styles.checkboxGroup }>
        <label className={styles.checkboxLabel}>
          <input type="checkbox" value="Instagram"  />
          Instagram
        </label>
        <label className={styles.checkboxLabel}>
          <input type="checkbox" value="LinkedIn"/>
          Linkedin
        </label>
        <label className={styles.checkboxLabel}>
          <input type="checkbox" value="Youtube" />
          Youtube
        </label>
        <label className={styles.checkboxLabel}>
          <input type="checkbox" value="Facebook" />
          Facebook
        </label>
        <label className={styles.checkboxLabel}>
          <input type="checkbox" value="Google" />
          Google
        </label>

      </div>
      {
          errors.platforms && touched.platforms && <p style={{ color: "red", fontSize: "12px", textAlign: "left" }}>{errors.platforms}</p>

      }
                   </div> */}
                        <div className={styles.inputMobileResponsive}>
                            <label className={styles.label}>Platform</label>
                            <div className={styles.checkboxGroup}>
                                <label className={styles.checkboxLabel}>
                                    <input
                                        type="checkbox"
                                        value="Instagram"
                                        onChange={(e) => handleCheckboxChange(e, 'Instagram')}
                                        checked={values.platforms.includes('Instagram')}
                                    />
                                    Instagram
                                </label>
                                <label className={styles.checkboxLabel}>
                                    <input
                                        type="checkbox"
                                        value="LinkedIn"
                                        onChange={(e) => handleCheckboxChange(e, 'LinkedIn')}
                                        checked={values.platforms.includes('LinkedIn')}
                                    />
                                    Linkedin
                                </label>
                                <label className={styles.checkboxLabel}>
                                    <input
                                        type="checkbox"
                                        value="Youtube"
                                        onChange={(e) => handleCheckboxChange(e, 'Youtube')}
                                        checked={values.platforms.includes('Youtube')}
                                    />
                                    Youtube
                                </label>
                                <label className={styles.checkboxLabel}>
                                    <input
                                        type="checkbox"
                                        value="Facebook"
                                        onChange={(e) => handleCheckboxChange(e, 'Facebook')}
                                        checked={values.platforms.includes('Facebook')}
                                    />
                                    Facebook
                                </label>
                                <label className={styles.checkboxLabel}>
                                    <input
                                        type="checkbox"
                                        value="Google"
                                        onChange={(e) => handleCheckboxChange(e, 'Google')}
                                        checked={values.platforms.includes('Google')}
                                    />
                                    Google
                                </label>
                            </div>
                            {errors.platforms && touched.platforms && (
                                <p style={{ color: "red", fontSize: "12px", textAlign: "left" }}>{errors.platforms}</p>
                            )}
                        </div>
                        <div className={styles.inputboxStyle}>
                            <div className={styles.inputMobileResponsive} >
                                <label className={styles.label}>Password</label>
                                <div className={styles.inputBox}>
                                    <input
                                        type={showNewPassword ? 'text' : 'password'}
                                        onBlur={handleBlur}
                                        value={values.password}
                                        placeholder='Password'
                                        name="password"
                                        onChange={handleChange}
                                        autocomplete="new-password"
                                    />
                                    <div onClick={() => setShowNewPassword(!showNewPassword)} style={{ display: 'flex', alignItems: 'center', justifyContent: "center" }}>
                                        {showNewPassword ? <PasswordVisible /> : <HidePasswordIcon />}
                                    </div>
                                </div>
                                {
                                    errors.password && touched.password && <p style={{ color: "red", fontSize: "12px", textAlign: "left" }}>{errors.password}</p>
                                }
                            </div>
                            <div className={styles.inputMobileResponsive} >
                                <label className={styles.label}>Confirm Password</label>
                                <div className={styles.inputBox}>
                                    <input
                                        type={showNewPassword ? 'text' : 'password'}
                                        onBlur={handleBlur}
                                        value={values.confirmPassword}
                                        placeholder='Confirm Password'
                                        name="confirmPassword"
                                        onChange={handleChange}
                                        autocomplete="new-password"
                                    />
                                    <div onClick={() => setShowNewPassword(!showNewPassword)}>
                                        {showNewPassword ? <PasswordVisible /> : <HidePasswordIcon />}
                                    </div>
                                </div>
                                {
                                    errors.confirmPassword && touched.confirmPassword && <p style={{ color: "red", fontSize: "12px", textAlign: "left" }}>{errors.confirmPassword}</p>
                                }
                            </div>
                        </div>

                        <div style={{ transform: "scale(0.7)", transformOrigin: "0 0", marginTop: "10px" }}>
                            <ReCAPTCHA
                                sitekey="6Lc8vBcrAAAAANcniDVhDJlYjI_dim7gFk3L4u19"
                                onChange={handleCaptchaChange}
                                style={{ height: "40px" }}
                            />
                        </div>
                    </form>
                    <div className={styles.checkStyle} style={{ marginTop: 20 }}>
                        <div style={{ marginLeft: -10, display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <Checkbox
                                checked={checked}
                                onChange={handleTerms}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                            <div>
                                <span className={styles.agreeText}>I Agree with all of your <span style={{ color: '#564FFD' }}>Terms & Conditions</span> </span>
                            </div>
                        </div>
                        <div className={styles.saveButtonStyle} onClick={handleSubmit} disabled={loading}>
                            {
                                loading ?
                                    <CircularProgress size={25} thickness={4.5} sx={{ color: "#fff" }} />
                                    : "Create Account "
                            } <ArrowIcon />
                        </div>
                    </div>
                    <div style={{ marginTop: 20 }}>
                        <div onClick={handleGoogleSignUp}>
                            <div className={styles.signWith} style={{ marginTop: 20 }}>
                                <div className={styles.lineStyle} />
                                <div className={styles.orText}>
                                    SIGN UP WITH
                                </div>
                                <div className={styles.lineStyle} />
                            </div>
                            <div className={styles.google}>
                                <div className={styles.googleStyle}>
                                    <GoogleIcon /> <div className={styles.singleLine} />Google
                                </div>
                            </div>
                        </div>
                        <div className={styles.textStyle}>
                            Already at Kingster? <span className={styles.loginText} onClick={() => navigate('/affiliate/login')}>Login</span>
                        </div>
                    </div>

                </div>
            </div>

            <AffiliateRegistrationModal
                open={otpModal}
                closeModal={() => setOtpModal(false)}
                desc={`We have sent you an OTP to your  ${maskEmail(values?.email)}, please check and verify.`}
                data={values}
                setShowModal={setShowModal}
            />


            <PendingModal
                open={showModal} />
        </div>
    )
}



export default AffiliateRegistration;
